module.exports = __webpack_public_path__ + "img/camarote.768d9b9b.svg";